import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdministracionLineasCreditoComponent} from './Components/administracion-lineas-credito/administracion-lineas-credito.component';
import {AdministracionMontosIntermediarioComponent} from './Components/administracion-montos-intermediario/administracion-montos-intermediario.component';
import {AdministracionGarantiaIntermediarioComponent} from './Components/administracion-garantia-intermediario/administracion-garantia-intermediario.component';

import {AdministracionUbicacionesComponent} from './Components/administracion-ubicaciones/administracion-ubicaciones.component';
import {CrearLineasCreditoComponent} from './Components/crear-lineas-credito/crear-lineas-credito.component';
import {CrearUbicacionesIntermediarioComponent} from './Components/crear-ubicaciones-intermediario/crear-ubicaciones-intermediario.component';
import {CrearUsuarioIFComponent} from './Components/CrearUsuarioIF/crear-usuario-if/crear-usuario-if.component';
import {HomeIntermediarioFinancieroComponent} from './Components/home-intermediario-financiero/home-intermediario-financiero.component';
import {LoginIFComponent} from './Components/LoginIF/login-if/login-if.component';
import {ParametrizacionActividadesEconomicasComponent} from './Components/parametrizacion-actividades-economicas/parametrizacion-actividades-economicas.component';
import {PropuestaIntermediarioComponent} from './Components/propuesta-intermediario/propuesta-intermediario.component';
import {RevisarSolicitudesIfComponent} from './Components/revisar-solicitudes-if/revisar-solicitudes-if.component';
import {AprobarSolicitudesIfComponent} from './Components/aprobar-solicitudes-if/aprobar-solicitudes-if.component';
import {AprobarOfertaIfComponent} from './Components/aprobar-oferta-if/aprobar-oferta-if.component';
import {NegarOfertaIfComponent} from './Components/negar-oferta-if/negar-oferta-if.component';
import {DevolverOfertaIfComponent} from './Components/devolver-oferta-if/devolver-oferta-if.component';
import {EditarUbicacionesIntermediarioComponent} from './Components/editar-ubicaciones-intermediario/editar-ubicaciones-intermediario.component';
import {ConfirmarNegacionIfComponent} from './Components/confirmar-negacion-if/confirmar-negacion-if.component';
import {DevolverNegacionIfComponent} from './Components/devolver-negacion-if/devolver-negacion-if.component';
import {VerDetallePropuestaComponent} from './Components/ver-detalle-propuesta/ver-detalle-propuesta.component';
import {LayoutComponent} from './Components/layout/layout.component';
import {ModificarUsuarioIfPrincipalComponent} from './Components/modificar-usuario-if-principal/modificar-usuario-if-principal.component';
import {AdministracionFechaYHoraComponent} from './Components/administrar-fechas-y-rangos/administracion-fecha-y-hora/administracion-fecha-y-hora.component';
import {EditarUsuarioIfComponent} from './Components/editar-usuario-if/editar-usuario-if.component';
import {CrearParametrizacionComponent} from './Components/administrar-fechas-y-rangos/crear-parametrizacion/crear-parametrizacion.component';
import {ConfirmarDesembolsoSolicitudMicroempresarioComponent} from './Components/confirmar-desembolso-solicitud-microempresario/confirmar-desembolso-solicitud-microempresario.component';
import {DesbloquearUsuariosComponent} from './Components/desbloquear-usuarios/desbloquear-usuarios.component';
import {ConsultaPerfilesIfComponent} from './Components/consulta-perfiles-if/consulta-perfiles-if.component';
import {ConsultaRolesNoutilizadosifComponent} from './Components/consulta-roles-noutilizadosif/consulta-roles-noutilizadosif.component';
import {UserGuard} from './guards/user.guard';
import {ConsultarHistoricoUsuariosIFComponent} from './Components/consultar-historico-usuarios-if/consultar-historico-usuarios-if.component';
import {CambiarContrasenaComponent} from './Components/cambiar-contrasena/cambiar-contrasena.component';
import {ConsultaSolicitudesIfComponent} from './Components/consulta-solicitudes-if/consulta-solicitudes-if.component';
import {ConsultaDesembolsoIfComponent} from './Components/consulta-desembolso-if/consulta-desembolso-if.component';
import {ConsultarLogsAuditoriaComponent} from './Components/consultar-logs-auditoria/consultar-logs-auditoria.component';
import {ConsultarMicroempresariosComponent} from './Components/consultar-microempresarios/consultar-microempresarios.component';
import {ConsultarHistoricoSolicitudesComponent} from './Components/consultar-historico-solicitudes/consultar-historico-solicitudes.component';
import {ConsultarCuentasDeCobroComponent} from './Components/consultar-cuentas-de-cobro/consultar-cuentas-de-cobro.component';
import {VerDetalleComisionComponent} from './Components/ver-detalle-comision/ver-detalle-comision.component';
import { AdministracionParametrizacionAliadoComponent } from './Components/administracion-parametrizacion-aliado/administracion-parametrizacion-aliado.component';
import { AdministrarNivelVentasComponent } from './Components/administrar-nivel-ventas/administrar-nivel-ventas.component';
import { AdministrarCentralesRiesgoComponent } from './Components/administrar-centrales-riesgo/administrar-centrales-riesgo.component';
import { AdministrarBurosCreditoComponent } from './Components/administrar-buros-credito/administrar-buros-credito.component';
import { sessionHomeRedirectGuard } from '../core/session-home-redirect.guard';
import { SessionHomeRedirectComponent } from '../core/session-home-redirect.component';

const ROUTES: Routes = [
  { path: 'login', component: LoginIFComponent },
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: 'home', component: HomeIntermediarioFinancieroComponent, canActivate: [UserGuard] },
      {
        path: 'administracion/crearUsuarioIF',
        component: CrearUsuarioIFComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/montos',
        component: AdministracionMontosIntermediarioComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/nivelVentas',
        component: AdministrarNivelVentasComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/garantia',
        component: AdministracionGarantiaIntermediarioComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/parametrizacionAliado',
        component: AdministracionParametrizacionAliadoComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/actividadesEconomicas',
        component: ParametrizacionActividadesEconomicasComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/lineascredito',
        component: AdministracionLineasCreditoComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/lineascredito/crear',
        component: CrearLineasCreditoComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/lineascredito/crear/:idLinea',
        component: CrearLineasCreditoComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/ubicaciones',
        component: AdministracionUbicacionesComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/ubicaciones/crear',
        component: CrearUbicacionesIntermediarioComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/ubicaciones/editar/:idDepartamento',
        component: EditarUbicacionesIntermediarioComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/administrarCentralRiesgo',
        component: AdministrarCentralesRiesgoComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'transaccional/revisarSolicitudes/propuestaIntermediario/:id',
        component: PropuestaIntermediarioComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'transaccional/revisarSolicitudes',
        component: RevisarSolicitudesIfComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'transaccional/aprobarSolicitudes',
        component: AprobarSolicitudesIfComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'transaccional/aprobarSolicitudes/aprobarOferta/:id',
        component: AprobarOfertaIfComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'transaccional/aprobarSolicitudes/negarOferta/:id',
        component: NegarOfertaIfComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'transaccional/aprobarSolicitudes/devolverOferta/:id',
        component: DevolverOfertaIfComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'transaccional/aprobarSolicitudes/confirmarNegacion/:id',
        component: ConfirmarNegacionIfComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'transaccional/aprobarSolicitudes/devolverNegacion/:id',
        component: DevolverNegacionIfComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'consultar/detallePropuestaIF/verDetallePropuesta/:id',
        component: VerDetallePropuestaComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/modificarUsuarioIf',
        component: ModificarUsuarioIfPrincipalComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/modificarUsuarioIf/:id',
        component: EditarUsuarioIfComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/administracionFechayHora',
        component: AdministracionFechaYHoraComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/administracionFechayHora/crear',
        component: CrearParametrizacionComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/administracionFechayHora/crear/:id',
        component: CrearParametrizacionComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'transaccional/confirmarDesembolsoSolicitudMicroempresario',
        component: ConfirmarDesembolsoSolicitudMicroempresarioComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/desbloquear/usuario',
        component: DesbloquearUsuariosComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'administracion/cambiarContrasena',
        component: CambiarContrasenaComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'consultas/perfiles',
        component: ConsultaPerfilesIfComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'consultas/rolesNoUtilizados',
        component: ConsultaRolesNoutilizadosifComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'consultas/historicoDeUsuarios',
        component: ConsultarHistoricoUsuariosIFComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'consultar/solicitudes',
        component: ConsultaSolicitudesIfComponent,
        canActivate: [UserGuard]
      },

      {
        path: 'consultar/desembolso',
        component: ConsultaDesembolsoIfComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'consultas/logsAuditoria',
        component: ConsultarLogsAuditoriaComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'consultas/aceptacionesEmpresarios',
        component: ConsultarMicroempresariosComponent,
      },
      {
        path: 'consultas/aprobacionesAliado',
        component: ConsultarHistoricoSolicitudesComponent,
        canActivate: [UserGuard]
      },
      {
        path: 'consultar/cuentasDeCobro',
        component: ConsultarCuentasDeCobroComponent,
      },
      {
        path: 'consultar/cuentasDeCobro/ver/:id',
        component: VerDetalleComisionComponent,
      },
      {
        path: 'administracion/parametrizacionBuros',
        component: AdministrarBurosCreditoComponent,
        canActivate: [UserGuard]
      },
      {
        path: '**',
        canActivate: [sessionHomeRedirectGuard],
        component: SessionHomeRedirectComponent,
      },
    ],
  },
];


@NgModule({
  imports: [RouterModule.forChild(ROUTES)],
  exports: [RouterModule],
})
export class IntermediarioRoutingModule { }
